module.exports = __webpack_public_path__ + "static/media/calendar1.69f62a27.png";